import { render, staticRenderFns } from "./CarrierSpecialist.vue?vue&type=template&id=21159fd4&scoped=true&"
import script from "./CarrierSpecialist.vue?vue&type=script&lang=js&"
export * from "./CarrierSpecialist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21159fd4",
  null
  
)

export default component.exports